import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

export const TenantWebsiteBaseHrefContext = createContext<string | null>(null);

export function useTenantWebsiteBaseHref(): string | null {
  return useContext(TenantWebsiteBaseHrefContext);
}

export const TimetableNotesEnabledContext = createContext<boolean>(true);

export function useTimetableNotesEnabled(): boolean {
  return useContext(TimetableNotesEnabledContext);
}
